import { Card } from '@mantine/core';
import { Clock, User } from 'lucide-react';
import { FC } from 'react';

import PriorityMarker from '@/components/PriorityMarker.tsx';
import Heading4 from '@/components/text/Heading4.tsx';
import Paragraph from '@/components/text/Paragraph.tsx';

import { urgency_priority_map } from '@/constants/urgency.ts';

import { DCTask } from '@/models/doc-cirrus/DCTask.ts';

import { dayjs } from '@/utils/dayjsSetup.ts';
import { cn } from '@/utils/styleUtils.ts';

interface Props {
    task: DCTask;
    onClick: (id: string, instance_id: string) => void;
    isSelected: boolean;
    disabled: boolean;
}

const TaskListItem: FC<Props> = ({ task, onClick, isSelected, disabled }) => {
    const handleClick = (): void => onClick(task.id, task.instance_id);

    return (
        <Card
            key={task.id}
            className={cn(
                'relative h-full cursor-pointer gap-2 rounded-lg bg-slate-200 shadow-md',
                isSelected && 'border border-green-300 bg-white',
                disabled && 'cursor-not-allowed'
            )}
            onClick={disabled ? undefined : handleClick}
        >
            {task.urgency && <PriorityMarker priority={urgency_priority_map[task.urgency]} />}
            <Heading4 className="text-sm font-bold">{task.title}</Heading4>
            {task.employee_name && (
                <Paragraph className="flex gap-2 text-sm text-slate-500">
                    <User className="size-4" />
                    {task.employee_name}
                </Paragraph>
            )}
            <Paragraph className="flex gap-2 text-sm text-slate-500">
                <Clock className="size-4" />
                {dayjs(task.alert_time).format('DD.MM.YYYY')}
            </Paragraph>
            {disabled && <div className="absolute left-0 top-0 h-full w-full rounded-lg bg-black opacity-30" />}
        </Card>
    );
};

export default TaskListItem;
